import { Injectable, inject } from '@angular/core';
import { Observable, of, switchMap, tap } from 'rxjs';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AnswersApiService } from './services/answers-api.service';
import { EQuestionnaireStatus } from './models/questionnaireGrid.model';
import { TostesStore } from './store/tostes-store';
import { TostPositionEnum, TostTypeEnum } from './shared/models/tostes.model';
import { EReplyStatus } from './models/recipients.model';

@Injectable({
    providedIn: 'root',
})
export class CanAnswerGuard implements CanActivate {
    constructor(
        private answerApiService: AnswersApiService,
        private router: Router
    ) { }
    #tostesStore = inject(TostesStore)


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        console.log("👈CanAnswerGuard activated for route:", route.url);
        const guid = route.params['guid'];
        // בדיקה האם המשתמש הגיע ישירות לURL (לא דרך ניווט באפליקציה)
        const isDirectNavigation = this.router.getCurrentNavigation()?.previousNavigation === null;

        return this.answerApiService.canAnswerToQuestionnarie(guid).pipe(
            switchMap((canAnswer) => {
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                if (canAnswer.status == EReplyStatus.NotStarted || canAnswer.status == EReplyStatus.InProgress) {
                    const submissionDate = new Date(canAnswer.submissionDateNTZ);
                    submissionDate.setHours(0, 0, 0, 0);
                    if (submissionDate >= today || canAnswer.isUnauthorized) {
                        return of(true);
                    }
                    else {
                        // אם הגיע ישירות - העבר לדף שגיאה עם סוג שגיאה "פג תוקף"
                        if (isDirectNavigation) {
                            this.router.navigate(['/error'], { queryParams: { type: 'expired' } });
                        } else {
                            // אם הגיע מתוך האפליקציה - הצג הודעה וחזור
                            this.#tostesStore.addTost({ guid: this.#tostesStore.generateGuid(), message: { en: "Sorry, the completion due date has passed", he: "מצטערים, תאריך ההגשה עבר" }, position: TostPositionEnum.BottomLeft, seconds: 5, type: TostTypeEnum.ERROR });
                            // this.router.navigate(['/main']);
                        }
                        return of(false);
                    }
                }
                else {
                    // אם הגיע ישירות - העבר לדף שגיאה עם סוג שגיאה "הושלם"
                    if (isDirectNavigation) {
                        this.router.navigate(['/error'], { queryParams: { type: 'completed' } });
                    } else {
                        // אם הגיע מתוך האפליקציה - הצג הודעה וחזור
                        this.#tostesStore.addTost({ guid: this.#tostesStore.generateGuid(), message: { en: "This questionnaire has already been completed", he: "שאלון זה כבר הושלם" }, position: TostPositionEnum.BottomLeft, seconds: 5, type: TostTypeEnum.SUCCESS });
                        // this.router.navigate(['/main']);
                    }
                    return of(false);
                }
            })
        );
    }
}